import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/shared/auth/AuthProvider'
import { loadConfig } from '@/shared/config'
import { router } from '@/app/router'
import { preferences } from '@/shared/preferences'
import { applyTheme } from '@/shared/theme'
import '@/styles/app.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // The HTTP layer already handles 401 by refreshing once; retrying an
      // auth failure here would just multiply the noise.
      retry: (failureCount, error) => {
        const status = (error as { httpStatus?: number }).httpStatus
        if (status && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
  },
})

// index.html already applied it before the first paint; this keeps the two
// in step if the stored value was one the inline script did not recognise.
applyTheme(preferences.read().theme)

// Config is loaded before the first render so nothing has to cope with a
// half-configured API base URL.
loadConfig().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </QueryClientProvider>
    </StrictMode>,
  )
})
